const styles = {
  dialogPaper: {
    borderRadius: "16px",
    overflow: "hidden",
    maxWidth: 460,
    width: "100%",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    position: "relative",
    background:
      "linear-gradient(135deg, #014638 0%, rgba(1, 70, 56, 0.85) 100%)",
    px: 3,
    py: 3,
    color: "white",
  },
  closeButton: {
    position: "absolute",
    top: 12,
    right: 12,
    color: "rgba(255,255,255,0.8)",
    "&:hover": { color: "white" },
    p: 0.5,
  },
  mailIconCircle: {
    width: 48,
    height: 48,
    borderRadius: "12px",
    backgroundColor: "#F7EE6F",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  mailIcon: {
    fontSize: 22,
    color: "#014638",
  },
  headerSubtitle: {
    fontSize: "0.85rem",
    color: "rgba(255,255,255,0.75)",
    mt: 0.25,
  },
  content: {
    px: 3,
    py: 3,
    overflowY: "auto",
    flex: 1,
  },
  descriptionText: {
    fontSize: "0.9rem",
    color: "#374151",
    mb: 2.5,
  },
  warningBox: {
    backgroundColor: "rgba(247, 238, 111, 0.2)",
    borderLeft: "4px solid #FFB11D",
    borderRadius: "8px",
    px: 2,
    py: 1.75,
    mb: 3,
  },
  warningTitle: {
    fontWeight: 700,
    fontSize: "0.95rem",
    color: "#9C4514",
    mb: 0.5,
  },
  warningText: {
    fontSize: "0.85rem",
    color: "#8D431B",
  },
  sectionLabel: {
    fontWeight: 700,
    fontSize: "0.95rem",
    color: "#111827",
    mb: 2,
  },
  permissionList: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 3,
  },
  permissionItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
  },
  permissionCheckCircle: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    backgroundColor: "#f2f3fe",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    mt: 0.25,
  },
  permissionCheckIcon: {
    fontSize: 14,
    color: "#8084FF",
  },
  permissionTitle: {
    fontWeight: 600,
    fontSize: "0.95rem",
    color: "#111827",
  },
  permissionSubtitle: {
    fontSize: "0.825rem",
    color: "#6B7280",
    mt: 0.25,
  },
  privacyBox: {
    backgroundColor: "#F9FAFB",
    borderRadius: "10px",
    px: 2,
    py: 1.75,
    mb: 3,
    display: "flex",
    alignItems: "flex-start",
    gap: 1.25,
  },
  shieldIcon: {
    fontSize: 16,
    color: "#374151",
    mt: 0.25,
    flexShrink: 0,
  },
  privacyText: {
    fontSize: "0.825rem",
    color: "#4B5563",
    lineHeight: 1.5,
  },
  laterButton: {
    display: "block",
    mx: "auto",
    mt: 1.5,
    color: "#6B7280",
    fontWeight: 500,
    textTransform: "none",
    "&:hover": { backgroundColor: "transparent", color: "#374151" },
  },
  doneButton: {
    backgroundColor: "#014638",
    color: "white",
    "&:hover": { backgroundColor: "rgba(1, 70, 56, 0.9)" },
  },
  successBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: 1.5,
    py: 2,
  },
  successIcon: {
    fontSize: 48,
    color: "#014638",
  },
  alertLink: {
    color: "#014638",
    fontWeight: 600,
  },
};

export default styles;
